// extracted by mini-css-extract-plugin
export default {"-large":"A1SpGbxEN0CrEbyVooT5","brandFonts":"nlKlc1KJWdAk2HdmovSx","brandFontItem":"W9jDJXb3RNSTc5L9MOA3"};